<template>
  <div class="header" :style="`background-color: ${color ? color : 'white'}`">
    <div class="left" v-if="showBack" @click="goBack">
      <Icon name="arrow-left" />
    </div>
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
import { Icon } from 'vant';
export default {
  components: { Icon },

  props: ['color'],
  computed: {
    title() {
      return this.$t('menu.' + this.$route.name);
    },
    showBack() {
      return this.$route.meta.goBack;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.header {
  height: 88px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.05);
  position: relative;
  .left {
    position: absolute;
    left: 0;
    width: 88px;
    height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 56px;
  }

  .title {
    font-size: 38px;
    font-weight: 500;
    line-height: 88px;
  }
}
</style>
